// In eine Funktion gekapselt: die Datei wird von mehreren Sections derselben
// Seite eingebunden. Eine Klassendeklaration auf oberster Ebene würfe ab dem
// zweiten Laden „Identifier has already been declared". customElements.define
// ist ohnehin geschützt; so bleibt auch die Klasse selbst lokal.
(() => {
/**
 * <lo-hero-video> — legt den Film über das Standbild
 * ==================================================
 *
 * Im Original lag hier ein YouTube-Embed. Der Nachbau spielt stattdessen die
 * MP4-Dateien, die ohnehin schon auf dem Shopify-CDN liegen: kein fremder
 * Player, keine Cookies von youtube.com, deutlich schneller.
 *
 * Im HTML steht nur das Standbild (<picture>, Handy/Desktop per media) — Bild
 * 0 des Films, der Browser lädt es sofort. Das <video> hat weder Quelle noch
 * poster. Bis 28.09.2026 standen dort poster und Quelle des Desktops, die
 * Handy-Fassung setzte erst dieses Skript: bei langsamem 4G kam das Handy-Bild
 * dadurch nach 6,5 s (Live-Abnahme).
 *
 * Die Fassung wird einmalig per matchMedia gewählt (`media` an <source> in
 * <video> kennen nicht alle Browser) und erst gesetzt, wenn das Standbild
 * geladen ist, damit der Film ihm keine Bandbreite nimmt. Bis zu seinem
 * ersten Bild ist der Film durchsichtig, darunter steht das Standbild.
 *
 * Ohne JavaScript und bei „Bewegung reduzieren“ bleibt das Standbild.
 * Verweigert der Browser Autoplay (iPhone im Stromsparmodus), wird der Film
 * ausgeblendet — sonst läge Safaris Abspielknopf über dem Standbild.
 */
class LoumeHeroVideo extends HTMLElement {
  connectedCallback() {
    if (this.vorbereitet) return;
    this.vorbereitet = true;

    const video = this.querySelector('video');
    const desktop = this.getAttribute('desktop-src');
    if (!video || !desktop) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const mobil = this.getAttribute('mobile-src');
    const quelle = mobil && window.matchMedia('(max-width: 767px)').matches ? mobil : desktop;
    const bild = this.querySelector('img');

    const starten = () => {
      if (this.gestartet) return;
      this.gestartet = true;
      // Für loume-kopf-kontrast.js (schätzt einen Film ohne lesbares Bild
      // nach seinem poster): das Standbild — dieselbe Adresse, sie kommt aus
      // dem Speicher, keine zweite Anfrage.
      if (bild && bild.naturalWidth > 0 && bild.currentSrc) video.poster = bild.currentSrc;
      video.muted = true;
      video.src = quelle;
      const versuch = video.play();
      if (versuch && typeof versuch.catch === 'function') {
        versuch.catch((fehler) => {
          if (fehler && fehler.name === 'NotAllowedError') video.hidden = true;
        });
      }
    };

    if (!bild || bild.complete) {
      starten();
    } else {
      bild.addEventListener('load', starten, { once: true });
      bild.addEventListener('error', starten, { once: true });
    }
  }
}

if (!customElements.get('lo-hero-video')) {
  customElements.define('lo-hero-video', LoumeHeroVideo);
}
})();
